import SectionRecord from "models/view-models/section-record";
import NotebookSectionContextMenu from "organisms/notebook-section-context-menu/notebook-section-context-menu";
import SectionDraggable from "organisms/section-drag-and-drop/section-draggable";
import React from "react";
import useNotebookBreakpoints from "utilities/hooks/domain/notebooks/use-notebook-breakpoints";
interface CodeReferenceActionsProps {
    section: SectionRecord;
}
const CodeReferenceActions = ({ section }: CodeReferenceActionsProps) => {
    const { isMobile } = useNotebookBreakpoints();
    return (
        <>
            {/* Drag and Drop button */}
            {!isMobile && <SectionDraggable section={section} />}

            <NotebookSectionContextMenu section={section} />
        </>
    );
};
export default CodeReferenceActions;
